export enum WorkflowTypeId {
  Care = 1,
  Registration = 2,
  Checkout = 3,
}
